import VueCompositionAPI from "@vue/composition-api";

export const CompositionAPI = {
	install(vue:any, options:any){
		vue.use(VueCompositionAPI);
	}
};